import React, { useState, useEffect } from 'react';
import FormSection from '../admin/sections/FormSection';
import FormSectionPhoto from '../admin/sections/FormSectionPhoto';
import FormSectionVideo from '../admin/sections/FormSectionVideo';
import FormSectionThumbnailVideo from '../admin/sections/FormSectionThumbnailVideo';
import { setResetFormat } from '../../utils/formatController';
import '../admin/sections/Presse.scss';

const formatDescriptions = {
  'article': '📝 Article texte sans média',
  'article-photo': '🖼️ Article avec image obligatoire',
  'article-video': '🎥 Article avec vidéo obligatoire',
  'article-thumbnail-video': '🖼️📹 Article avec miniature + vidéo',
};

const SectionCreer = ({
  category = 'culturel',
  sectionTitle = 'Culturel',
}) => {
  const [selectedFormat, setSelectedFormat] = useState('');

  const handleReset = () => setSelectedFormat('');
  useEffect(() => { setResetFormat(() => setSelectedFormat('')); }, []);

  return (
    <div className="presse-wrapper">
      <h2 className="presse-title">📍 Publication {sectionTitle}</h2>
      {!selectedFormat && (
        <>
          <label htmlFor="format" className="presse-label">Choisir un format :</label>
          <select
            id="format"
            value={selectedFormat}
            onChange={(e) => setSelectedFormat(e.target.value)}
            required
            className="presse-select"
          >
            <option value="">-- Sélectionner --</option>
            <option value="article">📝 Article</option>
            <option value="article-photo">🖼️ Article + Photo</option>
            <option value="article-video">🎥 Article + Vidéo</option>
            <option value="article-thumbnail-video">🖼️📹 Article + Miniature + Vidéo</option>
          </select>
        </>
      )}
      {selectedFormat && (
        <>
          <p className="presse-description">{formatDescriptions[selectedFormat]}</p>
          <div className="presse-form-container">
            {selectedFormat === 'article' && <FormSection onReset={handleReset} category={category} />}
            {selectedFormat === 'article-photo' && <FormSectionPhoto onReset={handleReset} category={category} />}
            {selectedFormat === 'article-video' && <FormSectionVideo onReset={handleReset} category={category} />}
            {selectedFormat === 'article-thumbnail-video' && <FormSectionThumbnailVideo onReset={handleReset} category={category} />}
          </div>
          <button onClick={handleReset} className="presse-reset-button">🔄 Changer de format</button>
        </>
      )}
    </div>
  );
};

export default SectionCreer;
